import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { OrganizationCompartments, organizationStorageKey } from '..';

export class AllOrganizationMetricsListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.TeamSelected) private readonly predicate: Observable<boolean>,
    @injectDataCache(organizationStorageKey)
    private readonly cache: DataCache<OrganizationCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('allMetrics');
        } else {
          this.cache.reset('allMetrics');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}

export class AllOrganizationsListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.TeamSelected) private readonly predicate: Observable<boolean>,
    @injectDataCache(organizationStorageKey)
    private readonly cache: DataCache<OrganizationCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('allOrganizations');
        } else {
          this.cache.reset('allOrganizations');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}

export class OrganizationListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.UserInitialized) private readonly predicate: Observable<boolean>,
    @injectDataCache(organizationStorageKey)
    private readonly cache: DataCache<OrganizationCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('organization');
        } else {
          this.cache.reset('organization');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
